import { combineReducers } from 'redux'
import projects from './projects/reducers'

const projectReducer = combineReducers({
  projects,
})

export default projectReducer
